module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.02aa6e7.eot";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fonts/Roboto-Medium/Roboto-Medium.eot
// module id = 7mFX
// module chunks = 24